import React, { useState } from "react";
import QuotaStats from "./QuotaStat";
import BankRevenueStats from "./BankStats";
import DownloadExcelButton from "./DownloadExcelButton";

const StatContainer = ({ downloadExcelRef }) => {
  const [startDate, setStartDate] = useState(() => {
    const now = new Date();
    return formatDateForInput(new Date(now.getFullYear(), now.getMonth(), 1));
  });
  
  const [endDate, setEndDate] = useState(() => {
    return formatDateForInput(new Date());
  });
  
  function formatDateForInput(date) {
    return date.toISOString().split('T')[0];
  }
  
  return (
    <div>
      <div className="flex flex-wrap gap-4 mb-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Start Date</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="border rounded p-2"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">End Date</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="border rounded p-2"
          />
        </div>
      </div>
      <BankRevenueStats 
        startDate={startDate} 
        setStartDate={setStartDate} 
        endDate={endDate} 
        setEndDate={setEndDate}
      />
      <QuotaStats 
        startDate={startDate} 
        setStartDate={setStartDate} 
        endDate={endDate} 
        setEndDate={setEndDate}
      />
      <div ref={downloadExcelRef}>
        <DownloadExcelButton />
      </div>
    </div>
  );
};

export default StatContainer;